import { formMachine } from '../../../xform';
import cardNumberConfig from './cardNumberConfig';
import cvvConfig from './cvv2Config';
import expirationDateConfig from './expirationDateConfig';
import fullNameConfig from './fullNameConfig';
const createCardFormMachine = () => formMachine.withContext({
    // DO NOT CHANGE: the order of these configs must mirror the position of the inputs in the UI for the error focus to work
    fieldConfigs: [
        fullNameConfig(),
        cardNumberConfig(),
        expirationDateConfig(),
        cvvConfig()
    ]
});
export default createCardFormMachine;
